export default "__VITE_ASSET__DaF1i3B0__"